/**
 * Ship-view tuning (`data/ship-views.json`, M10 P1a1), validated with Zod at load.
 *
 * - `perHullView`: a view is rebuilt whenever the model behind its entity changes (the flown slot after a Hangar
 *   switch, a streamed model landing). Off keeps the pre-M10 behaviour: a view keeps the model its def had when the
 *   view was built.
 */
import { z } from 'zod'
import shipViewsJson from '../data/ship-views.json'

export const shipViewsConfigSchema = z.object({ perHullView: z.boolean() }).strict()

export type ShipViewsConfig = z.infer<typeof shipViewsConfigSchema>

export function loadShipViewsConfig(raw: unknown = shipViewsJson): ShipViewsConfig {
  return shipViewsConfigSchema.parse(raw)
}
